module.exports = __webpack_public_path__ + "img/RBS04_5.51748cb8.jpg";